import React from 'react';
import Feature from '../../components/feature/Feature';
import './whatSam.css';

const WhatSam = () => (
    <div className="sam__whatSam section__margin" id="wsam" dir='rtl'>
        <div className="sam__whatSam-feature">
            <Feature title="توسعه فناوران رایا" text="شرکت توسعه فناوران رایا متشکل از مستعدترین برنامه نویسان، توسعه دهندگان وب، طراحان UI/UX، گرافیست ها و عکاسان می باشد که همواره در تلاش هستند تا به بهترین روش کسب و کار شما را با تکنولوژی روز دنیا همگام کند و با افتخار پله های رشد را برای شما سهولت بخشد." />
        </div>
        <div className="sam__whatSam-heading">
            <h1 className="gradient__text">درباره توسعه فناوران رایا:</h1>
            {/* <p>معرفی بیشتر:</p> */}
        </div>
        <div className="sam__whatSam-container">
            <Feature title="تیم طراحی و گرافیست" text="یکی از بزرگ ترین نقاط قوت ما داشتن تیم طراحی و گرافیست برای کسب و شما می باشد، تیم طراحی ما با توجه به تخصص و حوزه کاری شما با استفاده از طراحی روان شناسی شهودی در معرفی بهتر شما و جذب مخاطب کمک شایانی می کند." />
            <Feature title="تیم توسعه دهنده" text="تیم توسعه دهنده ما نسبت به نیاز شما از کاربردی ترین و بهترین متود های روز دنیا در حیطه توسعه وب سایت استفاده می کند تا بهترین نتیجه را برای شما به ارمغان بیاورد." />
            <Feature title="تیم پشتیبانی" text="از جمله مزیت های شرکت توسعه فناوران رایا استفاده از تیم پشتیبانی متخصص می باشد تا در تمام ۲۴ ساعت شبانه روز و ۷ روز هفته بتواند به پاسخگویی و رفع مشکل شما عزیزان بپردازد." />
        </div>
    </div>
);

export default WhatSam;
